import { memo } from 'react'
import type { GardenSectionModelProps } from '@/components/home/components/garden-section/garden-section.model'
import { useGardenSectionModel } from '@/components/home/components/garden-section/garden-section.model'
import { GardenSectionView } from '@/components/home/components/garden-section/garden-section.view'

export const GardenSectionViewModel = memo(function GardenSectionViewModel(
  props: GardenSectionModelProps,
) {
  const model = useGardenSectionModel(props)
  return <GardenSectionView {...model} />
})
